'use strict';

customerZone.run(['gettextCatalog', 'config', function(gettextCatalog, config){
    if ( config.language === 'fr_BE') { var langTag = 'fr-be'; }
    else if (config.language === 'nl_BE') { langTag = 'nl-be'; }
    else { langTag = 'en'; }

    gettextCatalog.setCurrentLanguage(langTag);
}]);
